/**
 * NOTE:
 * We require different api service based on the env (web / cordova)
 */
const { config } = require('../configuration');

/* eslint-disable global-require */
const api =
  process.env.CORDOVA && !config.isImprivata
    ? require('./api.cordova')
    : require('./api.webapp');
/* eslint-enable global-require */

module.exports = api;
